import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import media from 'src/styles/media';

const Tabs = ({ tabs, active, onClickTab }) => {
  const handleClickTab = index => {
    onClickTab(index);
  };

  return (
    <Root>
      {tabs.map((tab, index) => (
        <Tab active={index === active} key={tab} onClick={() => handleClickTab(index)}>
          {tab}
        </Tab>
      ))}
    </Root>
  );
};

Tabs.propTypes = {
  tabs: PropTypes.array,
  active: PropTypes.number
};

const Root = styled.div`
  position: absolute;
  top: 35px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 100;
  background: #fff;
  display: flex;
  @media (max-width: ${media.md}) {
    display: none;
  }
`;

const Tab = styled.span`
  position: relative;
  display: block;
  padding: 12px 25px 12px;
  white-space: nowrap;
  font-size: 12px;
  font-family: ${({ theme }) => theme.fontMedium};
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colorPrimary};
  cursor: pointer;
  &:last-child {
    &::after {
      display: none;
    }
  }
  &::after {
    content: '';
    position: absolute;
    height: 30%;
    width: 1px;
    background: ${({ theme }) => theme.colorPrimary};
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
  &::before {
    content: '';
    position: absolute;
    height: 1px;
    width: 25px;
    background: ${({ theme }) => theme.colorPrimary};
    left: 50%;
    bottom: 7px;
    transform: translateX(-50%) ${props => props.active ? 'scaleX(1)' : 'scaleX(0)'};
    transition: transform 0.25s;
  }
`;

export default Tabs;



// WEBPACK FOOTER //
// ./src/pages/Neighbourhood/elements/Map/elements/Tabs.js